export default {
    aerial_hazard: {
        name: "Aerial Hazard",
        url: "nwcg_lines_air_ops/aerial_hazard",
    },
    aviation_route: {
        name: "Aviation Route",
        url: "nwcg_lines_air_ops/aviation_route",
    },
    foam_drop: {
        name: "Foam Drop",
        url: "nwcg_lines_air_ops/foam_drop",
    },
    retardant_drop: {
        name: "Retardant Drop",
        url: "nwcg_lines_air_ops/retardant_drop",
    },
    temporary_flight_restriction: {
        name: "Temporary Flight Restriction",
        url: "nwcg_lines_air_ops/temporary_flight_restriction",
    },
    uas_launch_and_recovery_zone: {
        name: "Uas Launch And Recovery Zone",
        url: "nwcg_lines_air_ops/uas_launch_and_recovery_zone",
    },
    water_drop: {
        name: "Water Drop",
        url: "nwcg_lines_air_ops/water_drop",
    },
}
